import React from 'react';
import { FaCar, FaFacebook, FaTwitter, FaInstagram, FaYoutube, FaApple, FaGooglePlay } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="bg-black border-t border-amber-400">
      <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          
          <div>
            <div className="flex items-center mb-4">
              <FaCar className="h-8 w-8 text-amber-400" />
              <span className="ml-2 text-xl font-bold text-amber-400">Quick Wheels</span>
            </div>
            <p className="text-amber-400 text-sm mb-4">
              The best car rental service for your journeys.
            </p>
            <div className="flex space-x-4 text-amber-400">
              <a href="#" className="hover:text-white"><FaFacebook size={20} /></a>
              <a href="#" className="hover:text-white"><FaTwitter size={20} /></a>
              <a href="#" className="hover:text-white"><FaInstagram size={20} /></a>
            </div>
          </div>
          
          <div>
            <h4 className="font-bold text-amber-400 mb-4">Company</h4>
            <ul className="text-amber-400 text-sm space-y-2">
              <li><a href="#" className="hover:text-white">About Us</a></li>
              <li><a href="#" className="hover:text-white">Blog</a></li>
              <li><a href="#" className="hover:text-white">Careers</a></li>
              <li><a href="#" className="hover:text-white">Contact Us</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-bold text-amber-400 mb-4">Help</h4>
            <ul className="text-amber-400 text-sm space-y-2">
              <li><a href="#" className="hover:text-white">Contact</a></li>
              <li><a href="#" className="hover:text-white">Support</a></li>
              <li><a href="#" className="hover:text-white">FAQ</a></li>
              <li><a href="#" className="hover:text-white">Privacy Policy</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-bold text-amber-400 mb-4">Download</h4>
            <div className="flex flex-col space-y-3">
              {/* Updated: Added black Apple and Google Play logos */}
              <div className="bg-amber-400 text-black px-4 py-2 rounded-lg flex items-center justify-center text-sm space-x-2">
                <FaApple size={20} />
                <span>App Store</span>
              </div>
              <div className="bg-amber-400 text-black px-4 py-2 rounded-lg flex items-center justify-center text-sm space-x-2">
                <FaGooglePlay size={20} />
                <span>Google Play</span>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    
      {/* New bottom footer bar */}
      <div className="bg-black py-4 px-4 sm:px-6 lg:px-8 border-t border-amber-400">
        <div className="max-w-7xl mx-auto bg-slate-800 rounded-full py-3 px-6 flex justify-between items-center text-sm">
          {/* Social media icons */}
          <div className="flex space-x-4">
            <a href="#" className="text-white hover:text-amber-400 transition-colors duration-200"><FaFacebook size={20} /></a>
            <a href="#" className="text-white hover:text-amber-400 transition-colors duration-200"><FaTwitter size={20} /></a>
            <a href="#" className="text-white hover:text-amber-400 transition-colors duration-200"><FaInstagram size={20} /></a>
            <a href="#" className="text-white hover:text-amber-400 transition-colors duration-200"><FaYoutube size={20} /></a>
          </div>
          
          {/* Copyright text */}
          <p className="hidden md:block text-slate-400">
            © {new Date().getFullYear()} Car Rental. All rights reserved.
          </p>

          {/* Legal links */}
          <div className="flex space-x-4 text-amber-400">
            <a href="#" className="hover:text-white transition-colors duration-200">Privacy Policy</a>
            <a href="#" className="hover:text-white transition-colors duration-200">Terms and Conditions</a>
            <a href="#" className="hover:text-white transition-colors duration-200">Refund & Cancellation</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;